@file:OptIn(InternalResourceApi::class)

package showcaseapp.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/showcaseapp.composeapp.generated.resources/"

@delegate:ResourceContentHash(-1_274_107_001)
internal val Res.drawable.ai_summary_preview_autumn: DrawableResource by lazy {
      DrawableResource("drawable:ai_summary_preview_autumn", setOf(
        ResourceItem(setOf(), "${MD}drawable/ai_summary_preview_autumn.jpg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-924_610_073)
internal val Res.drawable.ai_summary_preview_city: DrawableResource by lazy {
      DrawableResource("drawable:ai_summary_preview_city", setOf(
        ResourceItem(setOf(), "${MD}drawable/ai_summary_preview_city.jpg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(508_133_531)
internal val Res.drawable.ic_album: DrawableResource by lazy {
      DrawableResource("drawable:ic_album", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_album.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_491_514_122)
internal val Res.drawable.ic_alist: DrawableResource by lazy {
      DrawableResource("drawable:ic_alist", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_alist.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_411_811_291)
internal val Res.drawable.ic_buy_me_coffee: DrawableResource by lazy {
      DrawableResource("drawable:ic_buy_me_coffee", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_buy_me_coffee.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_790_680_794)
internal val Res.drawable.ic_dropbox: DrawableResource by lazy {
      DrawableResource("drawable:ic_dropbox", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_dropbox.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_532_955_075)
internal val Res.drawable.ic_face_privacy: DrawableResource by lazy {
      DrawableResource("drawable:ic_face_privacy", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_face_privacy.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_088_026_580)
internal val Res.drawable.ic_face_privacy_checked: DrawableResource by lazy {
      DrawableResource("drawable:ic_face_privacy_checked", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_face_privacy_checked.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-607_729_318)
internal val Res.drawable.ic_folder: DrawableResource by lazy {
      DrawableResource("drawable:ic_folder", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_folder.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_628_481_443)
internal val Res.drawable.ic_ftp: DrawableResource by lazy {
      DrawableResource("drawable:ic_ftp", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_ftp.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_764_873_220)
internal val Res.drawable.ic_gallery: DrawableResource by lazy {
      DrawableResource("drawable:ic_gallery", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_gallery.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-480_840_929)
internal val Res.drawable.ic_gitee: DrawableResource by lazy {
      DrawableResource("drawable:ic_gitee", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_gitee.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_672_715_942)
internal val Res.drawable.ic_github: DrawableResource by lazy {
      DrawableResource("drawable:ic_github", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_github.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_717_199_536)
internal val Res.drawable.ic_github_lite: DrawableResource by lazy {
      DrawableResource("drawable:ic_github_lite", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_github_lite.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_747_307_992)
internal val Res.drawable.ic_google_drive: DrawableResource by lazy {
      DrawableResource("drawable:ic_google_drive", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_google_drive.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-436_487_034)
internal val Res.drawable.ic_google_photos: DrawableResource by lazy {
      DrawableResource("drawable:ic_google_photos", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_google_photos.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_040_816_323)
internal val Res.drawable.ic_image_folder: DrawableResource by lazy {
      DrawableResource("drawable:ic_image_folder", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_image_folder.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_665_307_559)
internal val Res.drawable.ic_immich: DrawableResource by lazy {
      DrawableResource("drawable:ic_immich", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_immich.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_682_948_389)
internal val Res.drawable.ic_info: DrawableResource by lazy {
      DrawableResource("drawable:ic_info", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_info.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_103_475_130)
internal val Res.drawable.ic_kofi: DrawableResource by lazy {
      DrawableResource("drawable:ic_kofi", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_kofi.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-225_960_675)
internal val Res.drawable.ic_launcher_background: DrawableResource by lazy {
      DrawableResource("drawable:ic_launcher_background", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_launcher_background.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-647_392_946)
internal val Res.drawable.ic_launcher_main: DrawableResource by lazy {
      DrawableResource("drawable:ic_launcher_main", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_launcher_main.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-208_477_369)
internal val Res.drawable.ic_launcher_tv: DrawableResource by lazy {
      DrawableResource("drawable:ic_launcher_tv", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_launcher_tv.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-915_420_097)
internal val Res.drawable.ic_mtphoto: DrawableResource by lazy {
      DrawableResource("drawable:ic_mtphoto", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_mtphoto.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(372_315_077)
internal val Res.drawable.ic_music_album: DrawableResource by lazy {
      DrawableResource("drawable:ic_music_album", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_music_album.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-470_258_645)
internal val Res.drawable.ic_onedrive: DrawableResource by lazy {
      DrawableResource("drawable:ic_onedrive", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_onedrive.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_290_164_906)
internal val Res.drawable.ic_pexels: DrawableResource by lazy {
      DrawableResource("drawable:ic_pexels", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_pexels.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_946_778_173)
internal val Res.drawable.ic_rss: DrawableResource by lazy {
      DrawableResource("drawable:ic_rss", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_rss.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-251_087_179)
internal val Res.drawable.ic_s3_bucket: DrawableResource by lazy {
      DrawableResource("drawable:ic_s3_bucket", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_s3_bucket.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-852_949_311)
internal val Res.drawable.ic_smb: DrawableResource by lazy {
      DrawableResource("drawable:ic_smb", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_smb.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_224_465_747)
internal val Res.drawable.ic_telegram_app: DrawableResource by lazy {
      DrawableResource("drawable:ic_telegram_app", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_telegram_app.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_078_110_923)
internal val Res.drawable.ic_terminal: DrawableResource by lazy {
      DrawableResource("drawable:ic_terminal", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_terminal.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_678_056_759)
internal val Res.drawable.ic_tmdb: DrawableResource by lazy {
      DrawableResource("drawable:ic_tmdb", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_tmdb.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_018_655_580)
internal val Res.drawable.ic_union: DrawableResource by lazy {
      DrawableResource("drawable:ic_union", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_union.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_065_769_617)
internal val Res.drawable.ic_unsplash: DrawableResource by lazy {
      DrawableResource("drawable:ic_unsplash", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_unsplash.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_351_936_761)
internal val Res.drawable.ic_unsplash_symbol: DrawableResource by lazy {
      DrawableResource("drawable:ic_unsplash_symbol", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_unsplash_symbol.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-340_511_359)
internal val Res.drawable.ic_weather_blizzard: DrawableResource by lazy {
      DrawableResource("drawable:ic_weather_blizzard", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_weather_blizzard.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-657_416_375)
internal val Res.drawable.ic_weather_clear_day: DrawableResource by lazy {
      DrawableResource("drawable:ic_weather_clear_day", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_weather_clear_day.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(47_076_709)
internal val Res.drawable.ic_weather_clear_night: DrawableResource by lazy {
      DrawableResource("drawable:ic_weather_clear_night", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_weather_clear_night.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_059_262_210)
internal val Res.drawable.ic_weather_cloudy: DrawableResource by lazy {
      DrawableResource("drawable:ic_weather_cloudy", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_weather_cloudy.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_323_748_467)
internal val Res.drawable.ic_weather_drizzle: DrawableResource by lazy {
      DrawableResource("drawable:ic_weather_drizzle", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_weather_drizzle.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_795_510_412)
internal val Res.drawable.ic_weather_flurries: DrawableResource by lazy {
      DrawableResource("drawable:ic_weather_flurries", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_weather_flurries.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(674_966_202)
internal val Res.drawable.ic_weather_haze_fog: DrawableResource by lazy {
      DrawableResource("drawable:ic_weather_haze_fog", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_weather_haze_fog.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-660_163_650)
internal val Res.drawable.ic_weather_heavy_rain: DrawableResource by lazy {
      DrawableResource("drawable:ic_weather_heavy_rain", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_weather_heavy_rain.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_547_131_386)
internal val Res.drawable.ic_weather_heavy_snow: DrawableResource by lazy {
      DrawableResource("drawable:ic_weather_heavy_snow", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_weather_heavy_snow.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(289_715_478)
internal val Res.drawable.ic_weather_mostly_cloudy_day: DrawableResource by lazy {
      DrawableResource("drawable:ic_weather_mostly_cloudy_day", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_weather_mostly_cloudy_day.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_132_944_876)
internal val Res.drawable.ic_weather_mostly_cloudy_night: DrawableResource by lazy {
      DrawableResource("drawable:ic_weather_mostly_cloudy_night", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_weather_mostly_cloudy_night.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(360_011_731)
internal val Res.drawable.ic_weather_not_available: DrawableResource by lazy {
      DrawableResource("drawable:ic_weather_not_available", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_weather_not_available.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_033_532_173)
internal val Res.drawable.ic_weather_partly_cloudy_day: DrawableResource by lazy {
      DrawableResource("drawable:ic_weather_partly_cloudy_day", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_weather_partly_cloudy_day.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_016_214_149)
internal val Res.drawable.ic_weather_partly_cloudy_night: DrawableResource by lazy {
      DrawableResource("drawable:ic_weather_partly_cloudy_night", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_weather_partly_cloudy_night.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(863_455_976)
internal val Res.drawable.ic_weather_rain_showers: DrawableResource by lazy {
      DrawableResource("drawable:ic_weather_rain_showers", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_weather_rain_showers.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-415_874_614)
internal val Res.drawable.ic_weather_scattered_rain_showers_day: DrawableResource by lazy {
      DrawableResource("drawable:ic_weather_scattered_rain_showers_day", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_weather_scattered_rain_showers_day.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_665_791_052)
internal val Res.drawable.ic_weather_scattered_rain_showers_night: DrawableResource by lazy {
      DrawableResource("drawable:ic_weather_scattered_rain_showers_night", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_weather_scattered_rain_showers_night.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-199_775_494)
internal val Res.drawable.ic_weather_scattered_snow_showers_day: DrawableResource by lazy {
      DrawableResource("drawable:ic_weather_scattered_snow_showers_day", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_weather_scattered_snow_showers_day.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(880_524_496)
internal val Res.drawable.ic_weather_scattered_snow_showers_night: DrawableResource by lazy {
      DrawableResource("drawable:ic_weather_scattered_snow_showers_night", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_weather_scattered_snow_showers_night.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(247_993_044)
internal val Res.drawable.ic_weather_snow_showers: DrawableResource by lazy {
      DrawableResource("drawable:ic_weather_snow_showers", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_weather_snow_showers.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_146_851_691)
internal val Res.drawable.ic_weather_strong_thunderstorms: DrawableResource by lazy {
      DrawableResource("drawable:ic_weather_strong_thunderstorms", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_weather_strong_thunderstorms.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-904_340_711)
internal val Res.drawable.ic_weather_thunderstorms_day: DrawableResource by lazy {
      DrawableResource("drawable:ic_weather_thunderstorms_day", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_weather_thunderstorms_day.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(847_054_948)
internal val Res.drawable.ic_weather_thunderstorms_night: DrawableResource by lazy {
      DrawableResource("drawable:ic_weather_thunderstorms_night", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_weather_thunderstorms_night.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_853_866_875)
internal val Res.drawable.ic_webdav: DrawableResource by lazy {
      DrawableResource("drawable:ic_webdav", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_webdav.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_706_325_236)
internal val Res.drawable.ic_weibo: DrawableResource by lazy {
      DrawableResource("drawable:ic_weibo", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_weibo.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_466_625_772)
internal val Res.drawable.ic_weibo_image: DrawableResource by lazy {
      DrawableResource("drawable:ic_weibo_image", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_weibo_image.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_061_013_034)
internal val Res.drawable.ic_x: DrawableResource by lazy {
      DrawableResource("drawable:ic_x", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_x.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_794_920_772)
internal val Res.drawable.ic_xiaohongshu: DrawableResource by lazy {
      DrawableResource("drawable:ic_xiaohongshu", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_xiaohongshu.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_280_121_923)
internal val Res.drawable.icon_163_music: DrawableResource by lazy {
      DrawableResource("drawable:icon_163_music", setOf(
        ResourceItem(setOf(), "${MD}drawable/icon_163_music.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_696_630_541)
internal val Res.drawable.icon_apple_music: DrawableResource by lazy {
      DrawableResource("drawable:icon_apple_music", setOf(
        ResourceItem(setOf(), "${MD}drawable/icon_apple_music.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_985_661_824)
internal val Res.drawable.icon_qq_music: DrawableResource by lazy {
      DrawableResource("drawable:icon_qq_music", setOf(
        ResourceItem(setOf(), "${MD}drawable/icon_qq_music.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_141_718_839)
internal val Res.drawable.icon_spotify: DrawableResource by lazy {
      DrawableResource("drawable:icon_spotify", setOf(
        ResourceItem(setOf(), "${MD}drawable/icon_spotify.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("ai_summary_preview_autumn", Res.drawable.ai_summary_preview_autumn)
  map.put("ai_summary_preview_city", Res.drawable.ai_summary_preview_city)
  map.put("ic_album", Res.drawable.ic_album)
  map.put("ic_alist", Res.drawable.ic_alist)
  map.put("ic_buy_me_coffee", Res.drawable.ic_buy_me_coffee)
  map.put("ic_dropbox", Res.drawable.ic_dropbox)
  map.put("ic_face_privacy", Res.drawable.ic_face_privacy)
  map.put("ic_face_privacy_checked", Res.drawable.ic_face_privacy_checked)
  map.put("ic_folder", Res.drawable.ic_folder)
  map.put("ic_ftp", Res.drawable.ic_ftp)
  map.put("ic_gallery", Res.drawable.ic_gallery)
  map.put("ic_gitee", Res.drawable.ic_gitee)
  map.put("ic_github", Res.drawable.ic_github)
  map.put("ic_github_lite", Res.drawable.ic_github_lite)
  map.put("ic_google_drive", Res.drawable.ic_google_drive)
  map.put("ic_google_photos", Res.drawable.ic_google_photos)
  map.put("ic_image_folder", Res.drawable.ic_image_folder)
  map.put("ic_immich", Res.drawable.ic_immich)
  map.put("ic_info", Res.drawable.ic_info)
  map.put("ic_kofi", Res.drawable.ic_kofi)
  map.put("ic_launcher_background", Res.drawable.ic_launcher_background)
  map.put("ic_launcher_main", Res.drawable.ic_launcher_main)
  map.put("ic_launcher_tv", Res.drawable.ic_launcher_tv)
  map.put("ic_mtphoto", Res.drawable.ic_mtphoto)
  map.put("ic_music_album", Res.drawable.ic_music_album)
  map.put("ic_onedrive", Res.drawable.ic_onedrive)
  map.put("ic_pexels", Res.drawable.ic_pexels)
  map.put("ic_rss", Res.drawable.ic_rss)
  map.put("ic_s3_bucket", Res.drawable.ic_s3_bucket)
  map.put("ic_smb", Res.drawable.ic_smb)
  map.put("ic_telegram_app", Res.drawable.ic_telegram_app)
  map.put("ic_terminal", Res.drawable.ic_terminal)
  map.put("ic_tmdb", Res.drawable.ic_tmdb)
  map.put("ic_union", Res.drawable.ic_union)
  map.put("ic_unsplash", Res.drawable.ic_unsplash)
  map.put("ic_unsplash_symbol", Res.drawable.ic_unsplash_symbol)
  map.put("ic_weather_blizzard", Res.drawable.ic_weather_blizzard)
  map.put("ic_weather_clear_day", Res.drawable.ic_weather_clear_day)
  map.put("ic_weather_clear_night", Res.drawable.ic_weather_clear_night)
  map.put("ic_weather_cloudy", Res.drawable.ic_weather_cloudy)
  map.put("ic_weather_drizzle", Res.drawable.ic_weather_drizzle)
  map.put("ic_weather_flurries", Res.drawable.ic_weather_flurries)
  map.put("ic_weather_haze_fog", Res.drawable.ic_weather_haze_fog)
  map.put("ic_weather_heavy_rain", Res.drawable.ic_weather_heavy_rain)
  map.put("ic_weather_heavy_snow", Res.drawable.ic_weather_heavy_snow)
  map.put("ic_weather_mostly_cloudy_day", Res.drawable.ic_weather_mostly_cloudy_day)
  map.put("ic_weather_mostly_cloudy_night", Res.drawable.ic_weather_mostly_cloudy_night)
  map.put("ic_weather_not_available", Res.drawable.ic_weather_not_available)
  map.put("ic_weather_partly_cloudy_day", Res.drawable.ic_weather_partly_cloudy_day)
  map.put("ic_weather_partly_cloudy_night", Res.drawable.ic_weather_partly_cloudy_night)
  map.put("ic_weather_rain_showers", Res.drawable.ic_weather_rain_showers)
  map.put("ic_weather_scattered_rain_showers_day", Res.drawable.ic_weather_scattered_rain_showers_day)
  map.put("ic_weather_scattered_rain_showers_night", Res.drawable.ic_weather_scattered_rain_showers_night)
  map.put("ic_weather_scattered_snow_showers_day", Res.drawable.ic_weather_scattered_snow_showers_day)
  map.put("ic_weather_scattered_snow_showers_night", Res.drawable.ic_weather_scattered_snow_showers_night)
  map.put("ic_weather_snow_showers", Res.drawable.ic_weather_snow_showers)
  map.put("ic_weather_strong_thunderstorms", Res.drawable.ic_weather_strong_thunderstorms)
  map.put("ic_weather_thunderstorms_day", Res.drawable.ic_weather_thunderstorms_day)
  map.put("ic_weather_thunderstorms_night", Res.drawable.ic_weather_thunderstorms_night)
  map.put("ic_webdav", Res.drawable.ic_webdav)
  map.put("ic_weibo", Res.drawable.ic_weibo)
  map.put("ic_weibo_image", Res.drawable.ic_weibo_image)
  map.put("ic_x", Res.drawable.ic_x)
  map.put("ic_xiaohongshu", Res.drawable.ic_xiaohongshu)
  map.put("icon_163_music", Res.drawable.icon_163_music)
  map.put("icon_apple_music", Res.drawable.icon_apple_music)
  map.put("icon_qq_music", Res.drawable.icon_qq_music)
  map.put("icon_spotify", Res.drawable.icon_spotify)
}
